import React from 'react';
import { Info16Regular } from '@fluentui/react-icons';
import { Tooltip } from '@fluentui/react-components';
import { formatDateTimeUTC } from './utils';

/**
 * Component for column header with UTC info icon
 */
export function TimeColumnHeader({ children }: { children: React.ReactNode }): React.JSX.Element {
  return (
    <div style={{ display: 'flex', alignItems: 'center', gap: '4px' }}>
      <span>{children}</span>
      <Tooltip content="The below time is in UTC timezone" relationship="label">
        <Info16Regular style={{ color: '#0f6cbd', cursor: 'pointer', fontSize: '12px' }} />
      </Tooltip>
    </div>
  );
}

/**
 * Component for displaying formatted date in table cells
 */
export function FormattedDateTime({ dateTime }: { dateTime: string | null | undefined }): React.JSX.Element {
  const formattedDate = formatDateTimeUTC(dateTime);
  return <span>{formattedDate}</span>;
}